import React from 'react';
import { motion } from 'framer-motion';
import meca from '../assets/meca.png'; 
import ray from '../assets/ray.png'; 
import robo from '../assets/robo.png'; 

const Hero = () => {
  return (
    <section style={{ textAlign: 'center', padding: '4rem 1rem', background: '#eaf6ff' }}>
      <motion.h2 initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }}>
        Servicios en Ingeniería Mecánica, Eléctrica, Automatización, Metrología, Desarrollo de Software, Logística y Transporte, Venta de equipos, accesorios, repuestos y más...
      </motion.h2>
      <motion.p initial={{ y: 50, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 0.3 }}>
        Una gran variedad de servicios en ingeniería para ofrecer servicios integrales y más...
      </motion.p>

      <div style={{ display: 'flex', justifyContent: 'center', gap: '2rem', marginTop: '3rem', flexWrap: 'wrap' }}>
        {[meca, ray, robo].map((img, idx) => (
          <motion.img
            key={idx}
            src={img}
            alt={`imagen-${idx}`}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            animate={{
              x: [0, 30, 0], // mueve de 0 a 30px a la derecha y regresa
            }}
            transition={{
              duration: 4,
              repeat: Infinity,
              repeatType: 'loop',
              ease: 'easeInOut',
              delay: idx * 0.5 // para que no se muevan exactamente igual
            }}
            style={{
              width: '300px',
              marginBottom: '1rem',
              cursor: 'pointer',
              borderRadius: '12px'
            }}
            onClick={() => window.location.href = "#contacto"}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;

